module.exports = __webpack_public_path__ + "img/JP-COVER.5646d469.png";